export default class PayrollReportRequest {
    shiftWeekCommencing: string;
    approvedOnOrAfter: string;
}